import { toggleMark } from "prosemirror-commands";
import { openPrompt } from "./prompt";
export function markActive(state, type) {
  const {
    from,
    $from,
    to,
    empty
  } = state.selection;
  if (empty) return type.isInSet(state.storedMarks || $from.marks());
  return state.doc.rangeHasMark(from, to, type);
}
export function setAlignment(state, dispatch, markType, value) {
  if (dispatch) {
    dispatch(state.tr.addMark(state.selection.from, state.selection.to, markType.create({
      textAlign: value
    })));
  }
  return true;
}
export function setFontFamily(state, dispatch, view, markType, value) {
  if (dispatch) {
    const {
      selection,
      tr
    } = state;
    const {
      from,
      to
    } = selection;
    if (from === to) {
      dispatch(tr.addStoredMark(markType.create({
        fontFamily: value
      })));
    } else {
      dispatch(tr.addMark(from, to, markType.create({
        fontFamily: value
      })));
    }
  }
  view.focus();
  return true;
}
export const toggleLinkItem = markType => (state, dispatch, view) => {
  if (markActive(state, markType)) {
    toggleMark(markType)(state, dispatch);
    return true;
  }
  const selectedText = state.doc.textBetween(state.selection.from, state.selection.to);
  openPrompt({
    title: __('Create a link'),
    fields: [{
      name: 'title',
      label: __('Title'),
      type: 'input'
    }, {
      name: 'href',
      label: __('Link target'),
      type: 'input',
      required: true,
      rules: [{
        required: true,
        message: __('Please input proper link target'),
        pattern: /^(?:(?:(?:f|ht)tps?|mailto|tel):|[^a-zA-Z0-9./#])/i
      }]
    }],
    initialValues: {
      title: selectedText,
      href: ''
    },
    callback(attrs) {
      toggleMark(markType, attrs)(view.state, view.dispatch);
      view.focus();
    }
  });
  return false;
};